module.exports = __webpack_public_path__ + "img/ch16_14_武警感谢.61aba0dd.jpg";